export const manualQuoteType = {
  "fcl-sea": "FCL - sea",
  "fcl-rail": "FCL - rail",
  "lcl-sea": "LCL - sea",
  "lcl-rail": "LCL - rail",
  ltl: "LTL",
  ftl: "FTL",
  ptl: "PTL",
  air: "AIR",
};
